import { jsx as o } from "react/jsx-runtime";
import g, { useState as i, useRef as x, useEffect as f, useLayoutEffect as F } from "react";
const d = g.createContext({
  isFullscreen: !1,
  toggleFullscreen: () => {
  }
}), u = (e) => e.fullscreenElement || e.webkitFullscreenElement, E = (e) => {
  var n, t;
  (n = e.requestFullscreen) != null && n.call(e) || ((t = e.webkitRequestFullScreen) == null || t.call(e));
}, a = () => {
  const e = document;
  u(e) && (e.exitFullscreen ? e.exitFullscreen() : e.webkitExitFullscreen && e.webkitExitFullscreen());
}, h = ({ children: e }) => {
  const [n, t] = i(!1), l = x(null), r = document;
  f(() => {
    if (!l.current)
      return;
    const c = u(r);
    n ? E(l.current) : c && a();
  }, [r, n]), F(() => {
    const c = () => {
      const v = u(r);
      t(!!v);
    };
    return r.addEventListener("fullscreenchange", c), () => {
      r.removeEventListener("fullscreenchange", c);
    };
  }, [r]);
  const s = () => {
    t(!n);
  };
  return /* @__PURE__ */ o(
    d.Provider,
    {
      value: {
        isFullscreen: n,
        toggleFullscreen: s
      },
      children: /* @__PURE__ */ o("div", { ref: l, style: { width: "100%", height: "100%" }, children: e })
    }
  );
}, b = ({ children: e }) => {
  const [n, t] = i(!1), l = document;
  f(() => {
    if (!(l != null && l.body))
      return;
    const s = u(l);
    n ? E(l.body) : s && a();
  }, [l, n]), F(() => {
    const s = () => {
      const c = u(l);
      t(!!c);
    };
    return l.addEventListener("fullscreenchange", s), () => {
      l.removeEventListener("fullscreenchange", s);
    };
  }, [l]);
  const r = () => {
    t(!n);
  };
  return /* @__PURE__ */ o(
    d.Provider,
    {
      value: {
        isFullscreen: n,
        toggleFullscreen: r
      },
      children: e
    }
  );
};
export {
  b as DeprecatedFullscreenContextProvider,
  d as FullscreenContext,
  h as FullscreenContextProvider
};
//# sourceMappingURL=index.es143.js.map
